module.exports = __webpack_public_path__ + "static/media/pocketcasts_podcasts.e5f9befb.svg";